module.exports = __webpack_public_path__ + "media/images/countrysquared/ba-fc0c67c1cd996fe14f26f70bbd4bf49d.svg";